import React from 'react';
import { useSelector } from 'react-redux';
import initContainerData from 'bdata-react-component/lib/store/initContainerData';
import matchupReducer from '../store/reducers/matchup';
import matchupDataRequestAction from '../store/actions/matchupDataRequestAction';
import teamvsPitcherDataSource from '@gameday/core/datasources/teamvsPitcher';
import { getMatchupState } from '../store/selectors/getLineupMatchup';
import Matchup from '../components/Matchup';
import scheduleDataSource from '@gameday/core/datasources/schedule';
import { StyledCard, DesktopWrapper } from '../LineupMatchup.style';
import { useMedia } from '@mlb/react-patterns/v4/utils/hooks/useMedia/useMedia';
import { GDBREAKPOINTS_NUM } from '@gameday/components/themes/breakpoints';

const fetchData = () => {
    return matchupDataRequestAction();
};

initContainerData.register({
    datasources: {
        teamvsPitcher: teamvsPitcherDataSource,
        schedule: scheduleDataSource
    },
    reducers: {
        previewmatchup: matchupReducer
    }
});

const routes = [{
    path: '/',
    exact: false,
    fetchData
}];

const MatchupDataContainer = () => {
    const isMobile = useMedia({ maxWidth: `${GDBREAKPOINTS_NUM.MD - 1}px` });
    const { matchup } = useSelector(getMatchupState);
    const { isDataLoaded, language } = matchup;
    const awayData = {
        ...matchup?.away,
        language,
        isDataLoaded
    };

    const homeData = {
        ...matchup?.home,
        language,
        isDataLoaded
    };

    return (
        <>
            { isMobile
                ? <StyledCard>
                    <Matchup data={homeData} />
                    <Matchup data={awayData} />
                </StyledCard>
                : <DesktopWrapper>
                    <StyledCard><Matchup data={homeData} /></StyledCard>
                    <StyledCard><Matchup data={awayData} /></StyledCard>
                </DesktopWrapper> }
        </>
    );
};

export default MatchupDataContainer;
export { fetchData, routes };
